package com.tregz.tremenz.io.cloud

import kotlin.js.Promise
import kotlinx.coroutines.await

@JsModule("firebase/app")
@JsNonModule
private external object AppModule {
    fun initializeApp(options: dynamic, name: String): dynamic
    fun getApps(): Array<dynamic>
}

@JsModule("firebase/auth")
@JsNonModule
private external object AuthModule {
    val browserLocalPersistence: dynamic
    val indexedDBLocalPersistence: dynamic
    fun initializeAuth(app: dynamic, deps: dynamic): dynamic
    fun signInAnonymously(auth: dynamic): Promise<dynamic>
}

@JsModule("firebase/firestore")
@JsNonModule
private external object FirestoreModule {
    fun collection(parent: dynamic, path: String): dynamic
    fun getDocs(query: dynamic): Promise<dynamic>
    fun getFirestore(app: dynamic): dynamic
}

@JsModule("firebase/storage")
@JsNonModule
private external object StorageModule {
    fun getDownloadURL(ref: dynamic): Promise<String>
    fun getStorage(app: dynamic): dynamic
    fun ref(storage: dynamic, path: String): dynamic
}

/**
 * The Tremenz project as a named app on the bundled modular SDK that Polyglot already loads,
 * so the page runs a single Firebase SDK next to Polyglot's default app.
 */
internal object CloudFirebase {
    private const val NAME = "tremenz"

    private val app: dynamic by lazy {
        AppModule.getApps().firstOrNull { it.name == NAME } ?: AppModule.initializeApp(options(), NAME)
    }

    // Anonymous sign-in only: no popup/redirect resolver, so this auth never loads the gapi iframe.
    private val auth: dynamic by lazy {
        val deps: dynamic = js("({})")
        deps.persistence = arrayOf(AuthModule.indexedDBLocalPersistence, AuthModule.browserLocalPersistence)
        AuthModule.initializeAuth(app, deps)
    }

    val firestore: dynamic by lazy { FirestoreModule.getFirestore(app) }
    val storage: dynamic by lazy { StorageModule.getStorage(app) }

    suspend fun signInAnonymously() {
        if (auth.currentUser == null) AuthModule.signInAnonymously(auth).await()
    }

    /** Documents of the [path] collection under [parent], a Firestore instance or a document reference. */
    suspend fun documents(parent: dynamic, path: String): dynamic =
        FirestoreModule.getDocs(FirestoreModule.collection(parent, path)).await()

    suspend fun downloadUrl(storage: dynamic, path: String): String =
        StorageModule.getDownloadURL(StorageModule.ref(storage, path)).await()

    private fun options(): dynamic {
        val config: dynamic = js("({})")
        config.apiKey = "AIzaSyDkUDGgSC-w-xe3PwwjiOXV2XedYpdVX6E"
        config.authDomain = "tremenz.firebaseapp.com"
        config.projectId = "tremenz"
        config.storageBucket = "tremenz.appspot.com"
        config.messagingSenderId = "32234575730"
        config.appId = "1:32234575730:web:cf0d2cf2abdced1352afeb"
        return config
    }
}
